module Administration {
    export function Init() {
        var dataTableSettings: DataTables.Settings = {
            pageLength: 25,
            "order": [[0, "asc"]],
        };

        Common.DataTableCustom.Init("userAdministrationTable", dataTableSettings);
    }

    interface IGenerateScriptData {
        customerId: string,
        environment: string,
        scriptId: string,
        scriptName: string,
        scriptVersion: string,
        removeDuplicates: boolean
    }

    export function PreviewTemplate(templateId: string, environment: string) {
        PlsWait.ShowLoader(true);
        var arrData: IGenerateScriptData[] = new Array();
        var arrScriptId: string[] = ['890', '889', '888', '887', '886', '885', '884', '883'];
        var arrScriptName: string[] = ['INSCRM_20190225_03_INS_ADMIN', 'INSCRM_20190225_02_INS_ADMIN', 'INSCRM_20190225_01_INS_GDPR', 'INSCRM_20190222_02_INS_GDPR', 'INSCRM_20190222_01_INS_GDPR', 'INSCRM_20190220_01_INS_LOY', 'INSCRM_20190219_04_INS_GDPR', 'INSCRM_20190219_03_INS_ACRM'];

        for (var i = 0; i < 8; i++) {
            var script: IGenerateScriptData = <IGenerateScriptData>{};
            script.customerId = templateId.toString();
            script.environment = environment;
            script.scriptId = arrScriptId[i];
            script.scriptName = arrScriptName[i];
            script.scriptVersion = '1';
            script.removeDuplicates = false;

            arrData.push(script);
        }

        arrData.sort((a, b) => (a.scriptName > b.scriptName) ? 1 : ((b.scriptName > a.scriptName) ? -1 : 0));

        var ajaxParams: JQueryAjaxSettings = {};
        ajaxParams.url = '/InstallTemplates/PreviewTemplate';
        ajaxParams.type = 'POST';
        ajaxParams.contentType = 'application/json';
        ajaxParams.xhr = function () {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob'
            return xhr;
        }
        ajaxParams.data = JSON.stringify(arrData);
        ajaxParams.processData = false;
        ajaxParams.success = (result, status, xhr) => {
            var blob = new Blob([result], { type: 'application/sql' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);

            // Pokušaj izvlaćenja imena od file-a ako ne uspije vrati scripts.zip
            var disposition = xhr.getResponseHeader('Content-Disposition');
            var fileName = 'scripts.sql';

            if (disposition && disposition.indexOf('filename=') !== -1) {
                var parts = disposition.split(';');
                for (var i = 0; i < parts.length; i++) {
                    var part = parts[i].trim();
                    if (part.startsWith('filename=')) {
                        // Kad neđe prvi izađi
                        fileName = part.replace('filename=', '').replace(/"/g, '').trim();
                        break;
                    }
                }
            }

            link.download = fileName;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);

            Notifications.GetNotification(`Datoteka ${fileName} uspiješno skinuta!`, 'success');
            PlsWait.ShowLoader(false);
        };
        ajaxParams.error = (err) => {
            Notifications.GetNotification(err.statusText, "danger");
            PlsWait.ShowLoader(false);
        };

        $.ajax(ajaxParams);
    }

    export module AppVersions {
        export function Init() {
            Administration.Init();

            $('#userAdministrationTable').on('click', '.edit-app-version', function () {
                var versionId = $(this).data("app-version");
                Dialog.OpenModal(`Izmjena verzije: ${versionId}`, 'Izmjeni', `/AppVersions/Edit/${versionId}`, 'Administracija');
            });

            $('#userAdministrationTable').on('click', '.delete-app-version', function () {
                var versionId = $(this).data("app-version");
                Dialog.OpenModal(`Brisanje verzije: ${versionId}`, 'Obriši', `/AppVersions/Delete/${versionId}`, 'Administracija');
            });

            $("#btnAddAppVersion").on("click", function () {
                Dialog.OpenModal('Nova verzija', 'Spremi', '/AppVersions/Create', 'Administracija')
            });
        }
    }

    export module ArhObjectLookup {
        export function Init() {
            Administration.Init();

            $('#userAdministrationTable').on('click', '.edit-arh-object-lookup', function () {
                var originalName = $(this).data("original-name");
                var id = $(this).data("id");
                Dialog.OpenModal(`Izmjena unosa: ${originalName}`, 'Izmjeni', `/ArhObjectLookup/Edit/${id}`, 'Administracija');
            });

            $('#userAdministrationTable').on('click', '.delete-arh-object-lookup', function () {
                var originalName = $(this).data("original-name");
                var id = $(this).data("id");
                Dialog.OpenModal(`Brisanje unosa: ${originalName}`, 'Obriši', `/ArhObjectLookup/Delete/${id}`, 'Administracija');
            });

            $("#btnAddArhObjectLookup").on("click", function () {
                Dialog.OpenModal('Novi unos', 'Spremi', '/ArhObjectLookup/Create', 'Administracija');
            });
        }
    }

    export module Customers {
        export function Init() {
            Administration.Init();

            $('#userAdministrationTable').on('click', '.edit-customer', function () {
                var customerName = $(this).data("customer");
                var customerId = $(this).data("id-company");
                Dialog.OpenModal(`Izmjena klijenta: ${customerName}`, 'Izmjeni', `/Customers/Edit/${customerId}`, 'Administracija');
            });

            $('#userAdministrationTable').on('click', '.delete-customer', function () {
                var customerName = $(this).data("customer");
                var customerId = $(this).data("id-company");
                Dialog.OpenModal(`Brisanje klijenta: ${customerName}`, 'Obriši', `/Customers/Delete/${customerId}`, 'Administracija');
            });

            $("#btnAddCustomer").on("click", function () {
                Dialog.OpenModal('Novi klijent', 'Spremi', '/Customers/Create', 'Administracija')
            });
        }
    }

    export module InstallTemplates {
        export function Init() {
            Administration.Init();

            $('#userAdministrationTable').on('click', '.edit-install-template', function () {
                var templateName = $(this).data("template-name");
                var templateId = $(this).data("id-template");
                var environment = $(this).data("environment");

                var envHeader = (environment.length > 0) ? `(${environment})` : "";

                Dialog.OpenModal(`Izmjena predloška: ${templateName} ${envHeader}`, 'Izmjeni', `/InstallTemplates/Edit/${templateId}`, 'Administracija', 'modal-xl');
            });

            $('#userAdministrationTable').on('click', '.delete-install-template', function () {
                var templateName = $(this).data("template-name");
                var templateId = $(this).data("id-template");
                var environment = $(this).data("environment");

                var envHeader = (environment.length > 0) ? `(${environment})` : "";
                Dialog.OpenModal(`Brisanje predloška: ${templateName} ${envHeader}`, 'Obriši', `/InstallTemplates/Delete/${templateId}`, 'Administracija', 'modal-xl');
            });

            $('#userAdministrationTable').on('click', '.preview-install-template', function () {
                var customerId = $(this).data("id-company");
                var environment = $(this).data("environment");

                Administration.PreviewTemplate(customerId, environment);
            });

            $("#btnAddInstallTemplate").on("click", function () {
                Dialog.OpenModal('Novi predložak', 'Spremi', '/InstallTemplates/Create', 'Administracija', 'modal-xl')
            });
        }

        export function InitCreate() {

            $('#IdCompany').on('change', function () {
                var companyId = $(this).val();
                var $env = $('#Environment');

                $env.empty().append('<option value="-1">Odaberite oklinu</option>');

                var ajaxParams: JQueryAjaxSettings = {};
                ajaxParams.url = '/InstallTemplates/GetEnvirnmentList';
                ajaxParams.type = 'POST';
                ajaxParams.contentType = 'application/json';
                ajaxParams.data = JSON.stringify({ idCompany: Number($(this).val()) });
                ajaxParams.success = (result) => {
                    $.each(result, function (_, env) {
                        $env.append(
                            $('<option>', { value: env.value, text: env.text })
                        );
                    });
                };
                ajaxParams.error = (err) => {
                    Notifications.GetNotification(err.statusText, "danger");
                    PlsWait.ShowLoader(false);
                };

                $.ajax(ajaxParams);
            });

            $('#IdCompany').change();
        }
    }

    export module Roles {
        export function Init() {
            Administration.Init();

            $('#userAdministrationTable').on('click', '.edit-role', function () {
                var roleName = $(this).data("role-name");
                var roleId = $(this).data("id-role");
                Dialog.OpenModal(`Izmjena uloge: ${roleName}`, 'Izmjeni', `/Roles/Edit/${roleId}`, 'Administracija');
            });

            $('#userAdministrationTable').on('click', '.delete-role', function () {
                var roleName = $(this).data("role-name");
                var roleId = $(this).data("id-role");
                Dialog.OpenModal(`Brisanje uloge: ${roleName}`, 'Obriši', `/Roles/Delete/${roleId}`, 'Administracija');
            });

            $("#btnAddRole").on("click", function () {
                Dialog.OpenModal('Nova uloga', 'Spremi', '/Roles/Create', 'Administracija')
            });
        }
    }

    export module Users {
        export function Init() {
            Administration.Init();

            $('#userAdministrationTable').on('click', '.edit-user', function () {
                var username = $(this).data("username");
                var userId = $(this).data("id-user");
                Dialog.OpenModal(`Izmjena korisnika: ${username}`, 'Izmjeni', `/Users/Edit/${userId}`, 'Administracija');
            });

            $('#userAdministrationTable').on('click', '.delete-user', function () {
                var username = $(this).data("username");
                var userId = $(this).data("id-user");
                Dialog.OpenModal(`Brisanje korisnika: ${username}`, 'Obriši', `/Users/Delete/${userId}`, 'Administracija');
            });

            $("#btnAddUser").on("click", function () {
                Dialog.OpenModal('Novi korisnik', 'Spremi', '/Users/Create', 'Administracija')
            });
        }
    }

    export module User {
        declare var QRCode;

        interface IRole {
            idRole: number,
            roleName: string
        }

        interface IUserRole {
            IdUser: number,
            Name: string,
            Surname: string,
            Username: string,
            Password: string,
            Email: string,
            CurrentCode: string,
            DefaultCompanyId: number,
            RoleList: IRole[]
        }

        export function Init(action: string) {
            $(".spc-role-item").click(function () {
                $(this).toggleClass("active");
            });

            $('#code').hide();

            if (action == 'Create') {
                $('input.form-control.required').on('blur', () => { ShowQrCode() });
            }
            else {
                $('#2FaChx').on('change', function () {
                    let isChacked = $(this).prop('checked');

                    $('#qrCode').html('');
                    $('#code').hide();

                    if (isChacked) {
                        ShowQrCode();
                    }
                });
            }

            // Bound on the form's submit event (not the button's click event): Dialog.OpenModal's
            // "Spremi" handler does $("#btnAdministration").off('click').click(), which strips any
            // click handler bound here and falls through to a native form submit. Submitting the
            // form still fires 'submit', so intercepting there survives that handler wipe and keeps
            // the request going out as JSON instead of a native x-www-form-urlencoded POST (which
            // the [FromBody] actions reject with 415).
            $("#btnAdministration").closest("form").off("submit").on("submit", function (evt) {
                evt.preventDefault();
                var user: IUserRole = <IUserRole>{};

                user.IdUser = $("#IdUser").val() as number;
                user.Name = $("#Name").val() as string;
                user.Surname = $("#Surname").val() as string;
                user.Username = $("#Username").val() as string;
                user.Password = $("#Password").val() as string;
                user.Email = $("#Email").val() as string;

                var defaultCompanyVal = $("#DefaultCompanyId").val() as string;
                user.DefaultCompanyId = defaultCompanyVal ? Number(defaultCompanyVal) : null;

                user.RoleList = new Array<IRole>();

                $(".spc-role-item.active").each(function () {
                    var role: IRole = <IRole>{};
                    role.idRole = $(this).children("input").val() as number;
                    role.roleName = $(this).children("label").text() as string;
                    user.RoleList.push(role);
                });

                var isEdit = action.indexOf('Edit') > -1;

                var ajaxParams: JQueryAjaxSettings = {};
                ajaxParams.url = '/Users/' + (isEdit ? (action + '/' + user.IdUser) : action);
                ajaxParams.type = 'POST';
                ajaxParams.contentType = 'application/json';
                ajaxParams.dataType = 'json';
                ajaxParams.data = JSON.stringify(user);
                ajaxParams.success = () => {
                    Notifications.GetNotification(isEdit ? 'Korisnik je uspješno izmijenjen.' : 'Korisnik je uspješno kreiran.', 'success');
                    setTimeout(() => location.reload(), 1200);
                };
                ajaxParams.error = (err) => {
                    Notifications.GetNotification(err.statusText, 'danger');
                };
                ajaxParams.complete = () => {
                    PlsWait.ShowLoader(false);
                };

                PlsWait.ShowLoader(true);
                $.ajax(ajaxParams);
            });
        }

        function ShowQrCode() {
            let validation: boolean = true;

            $('input.form-control.required').each(function () {
                if ($(this).val().toString() == '') {
                    validation = false;
                }
            });

            if (validation) {
                var currUser: IUserRole = <IUserRole>{};
                currUser.Name = $("#Name").val() as string;
                currUser.Surname = $("#Surname").val() as string;
                currUser.Username = $("#Username").val() as string;
                currUser.Password = $("#Password").val() as string;
                currUser.Email = $("#Email").val() as string;
                currUser.CurrentCode = "";

                var ajaxSettings: JQueryAjaxSettings = {};
                ajaxSettings.url = `/Users/NewTwoFacAuth`;
                ajaxSettings.type = 'POST';
                ajaxSettings.dataType = 'json';
                ajaxSettings.contentType = 'application/json';
                ajaxSettings.data = JSON.stringify(currUser);
                ajaxSettings.success = (result) => {
                    if (typeof result == 'string' && result.includes('Korisnik')) {
                        Reset2FAModal(currUser);
                    }
                    else {
                        GetQRCode('qrCode', result['AuthenticatorUri'], 200, 200);
                        $('#code').show();

                        $('#Name').attr('disabled', 'true');
                        $('#Surname').attr('disabled', 'true');
                        $('#Username').attr('disabled', 'true');
                        $('#Password').attr('disabled', 'true');
                        $('#Email').attr('disabled', 'true');

                        GetSixCode(currUser);
                    }

                    PlsWait.ShowLoader(false);
                };
                ajaxSettings.error = (err) => {
                    console.log(err.statusText);
                    PlsWait.ShowLoader(false);
                };

                $.ajax(ajaxSettings);
            }
        }

        function GetSixCode(currUser: IUserRole) {
            var oneTimeCode: JQuery<HTMLElement> = $('.otCode');

            oneTimeCode.on('keyup', function () {
                var numOfInputs: number = oneTimeCode.length;
                var isAllInputsFilled: boolean = false;
                var currInputValue: string = $(this).val().toString();

                if (currInputValue.length == 1) {
                    if (!isNaN(Number(currInputValue)) && currInputValue != ' ') {
                        isAllInputsFilled = true;

                        var curTabIndex: number = Number($(this).attr('tabIndex'));
                        var inputElement: JQuery<HTMLElement>;
                        oneTimeCode.each(function () {
                            if ($(this).val().toString().length == 0) {
                                isAllInputsFilled = false;
                            }
                        });

                        if (curTabIndex == numOfInputs) {
                            inputElement = $(`[tabIndex=1]`);
                        }
                        else {
                            inputElement = $(`[tabIndex=${curTabIndex + 1}]`);
                        }

                        inputElement.focus();
                        inputElement.select();
                    }
                    else {
                        $(this).val('');
                        $(this).focus();
                        $(this).select();
                    }
                }

                var currentCode: string = '';

                if (isAllInputsFilled) {
                    PlsWait.ShowLoader(true);
                    oneTimeCode.each(function () {
                        currentCode += $(this).val().toString();
                    });

                    currUser.CurrentCode = currentCode;

                    ValidateTwoFaCode(currUser);
                }
            });
        }

        function ValidateTwoFaCode(currUser: IUserRole) {
            var ajaxSettings: JQueryAjaxSettings = {};
            ajaxSettings.url = `/Users/CheckTwoFaAuth`;
            ajaxSettings.type = 'POST';
            ajaxSettings.dataType = 'json';
            ajaxSettings.contentType = 'application/json';
            ajaxSettings.data = JSON.stringify(currUser);
            ajaxSettings.success = (result) => {
                if (result != 'false') {
                    Notifications.GetNotification("Uspiješno aktivirana 2FA!", "success");
                }
                else {
                    Notifications.GetNotification("Ne ispravan 2FA kod!!!", "warning");
                }

                PlsWait.ShowLoader(false);
            };
            ajaxSettings.error = (err) => {
                Notifications.GetNotification("Greška vidi console", "danger");
                console.log(err.statusText);
                PlsWait.ShowLoader(false);
            };

            $.ajax(ajaxSettings);
        }

        function GetQRCode(elementId: string, uri: string, width: number, height: number) {
            new QRCode(document.getElementById(elementId),
                {
                    text: uri,
                    width: width,
                    height: height
                });
        }

        function Reset2FAModal(currUser: IUserRole) {
            $("#Reset2FaModal").modal({
                backdrop: 'static',
            });

            $('#btnGiveUp2FA').on('click', function () {
                $('#2FaChx').click();
            });

            $('#btnReset2FA').on('click', function () {
                var ajaxSettings: JQueryAjaxSettings = {};
                ajaxSettings.url = `/Users/ResetTwoFacAuth`;
                ajaxSettings.type = 'POST';
                ajaxSettings.dataType = 'json';
                ajaxSettings.contentType = 'application/json';
                ajaxSettings.data = JSON.stringify(currUser);
                ajaxSettings.success = (result) => {
                    ShowQrCode();
                    Notifications.GetNotification("Uspješno ste resetirali 2FA!", "success");
                    $("#Reset2FaModal").hide();
                };
                ajaxSettings.error = (err) => {
                    $("#Reset2FaModal").modal('hide');
                    Notifications.GetNotification(err.responseText, "warning");
                };

                $.ajax(ajaxSettings);
            });

            $('#Reset2FaModal').css('z-index', 1060).modal('show');
        }
    }

    export module UtilityScripts {
        export function Init() {
            Administration.Init();

            $('#userAdministrationTable').on('click', '.edit-utility', function () {
                var scriptName = $(this).data("utility");
                var idSctipt = $(this).data("id-script");
                Dialog.OpenModal(`Izmjena skripte: ${scriptName}`, 'Izmjeni', `/UtilityScripts/Edit/${idSctipt}`, 'Administracija', 'modal-xl');
            });

            $('#userAdministrationTable').on('click', '.delete-utility', function () {
                var scriptName = $(this).data("utility");
                var idSctipt = $(this).data("id-script");
                Dialog.OpenModal(`Brisanje skripte: ${scriptName}`, 'Obriši', `/UtilityScripts/Delete/${idSctipt}`, 'Administracija', 'modal-xl');
            });

            $('#userAdministrationTable').on('click', '.download-utility', function () {
                var scriptName = $(this).data("utility");
                var idSctipt = $(this).data("id-script");
                ScriptsPerCustomer.DownloadScript('UtilityScripts', scriptName);
            });

            $("#btnAddUtility").on("click", function () {
                Dialog.OpenModal('Nova skripta', 'Spremi', '/UtilityScripts/Create', 'Administracija', 'modal-xl')
            });
        }
    }

    export module UtilityScripts.Create {
        export function Init(): void {
            Common.FileZone.Init('ScriptFile');

            $('form[data-form="utility-form"]').on('submit', function (e) {
                e.preventDefault();

                PlsWait.ShowLoader(true);

                // Re-inject dropped file if browser cleared input.files
                var uploadInput = document.getElementById('ScriptFile') as HTMLInputElement;
                var droppedFile = Common.FileZone.GetDroppedFile();
                if (uploadInput && uploadInput.files && uploadInput.files.length === 0 && droppedFile) {
                    try {
                        var dt = new DataTransfer();
                        dt.items.add(droppedFile);
                        uploadInput.files = dt.files;
                    } catch (ex) { /* fallthrough */ }
                }

                let form = this as HTMLFormElement;
                let formData = new FormData(form);

                var ajaxParams: JQueryAjaxSettings = {};
                ajaxParams.url = '/UtilityScripts/Create';
                ajaxParams.type = 'POST';
                ajaxParams.data = formData;
                ajaxParams.processData = false;
                ajaxParams.contentType = false;
                ajaxParams.success = (result) => {
                    if (result.status == 'error') {
                        Notifications.GetNotification(result.message, "warning");
                        PlsWait.ShowLoader(false);
                        return false;
                    }

                    window.location.href = '/UtilityScripts';
                };
                ajaxParams.error = (err) => {

                    Notifications.GetNotification(err.statusText, "danger");
                    PlsWait.ShowLoader(false);
                };

                $.ajax(ajaxParams);
            });
        }
    }

    export module UtilityScripts.Edit {
        export function Init(): void {
            Common.FileZone.Init('ScriptFile');

            $('form[data-form="utility-form"]').on('submit', function (e) {
                e.preventDefault();

                PlsWait.ShowLoader(true);

                // Re-inject dropped file if browser cleared input.files
                var uploadInput = document.getElementById('ScriptFile') as HTMLInputElement;
                var droppedFile = Common.FileZone.GetDroppedFile();
                if (uploadInput && uploadInput.files && uploadInput.files.length === 0 && droppedFile) {
                    try {
                        var dt = new DataTransfer();
                        dt.items.add(droppedFile);
                        uploadInput.files = dt.files;
                    } catch (ex) { /* fallthrough */ }
                }

                let form = this as HTMLFormElement;
                let formData = new FormData(form);

                let idScript = $('#IdScript').val();

                var ajaxParams: JQueryAjaxSettings = {};
                ajaxParams.url = `/UtilityScripts/Edit/${idScript}`;
                ajaxParams.type = 'POST';
                ajaxParams.data = formData;
                ajaxParams.processData = false;
                ajaxParams.contentType = false;
                ajaxParams.success = (result) => {
                    if (result.status == 'error') {
                        Notifications.GetNotification(result.message, "warning");
                        PlsWait.ShowLoader(false);
                        return false;
                    }

                    window.location.href = '/UtilityScripts';
                };
                ajaxParams.error = (err) => {

                    Notifications.GetNotification(err.statusText, "danger");
                    PlsWait.ShowLoader(false);
                };

                $.ajax(ajaxParams);
            });
        }
    }

    export module UserErrorReport {
        var _charts: { [id: string]: any } = {};
        var _lastData: any = null;
        var _query: string = '';
        var _analyticsQuery: string = null;
        var _paletteSize: number = 8;
        var _dayNames: string[] = ['Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub', 'Ned'];

        export function Init(): void {
            var defaultFrom = $('#dateFrom').data('default').toString();
            var defaultTo = $('#dateTo').data('default').toString();

            $('#dateFrom').datepicker({ format: 'dd.mm.yyyy', autoclose: true, todayBtn: true, todayHighlight: true });
            $('#dateFrom').datepicker('update', Common.FormatDate(defaultFrom, 'eu'));
            $('#dateTo').datepicker({ format: 'dd.mm.yyyy', autoclose: true, todayBtn: true, todayHighlight: true });
            $('#dateTo').datepicker('update', Common.FormatDate(defaultTo, 'eu'));

            $('#uerUsers').select2({ placeholder: 'Svi korisnici', allowClear: true, width: '320px' });

            $('#uerApply').on('click', () => LoadData());
            $('#uerParserOnly').on('change', function () {
                $(this).closest('.uer-toggle').toggleClass('active', $(this).is(':checked'));
                LoadData();
            });

            $('.uer-preset').on('click', function () {
                applyPreset($(this).data('preset'));
                LoadData();
            });

            $('#uerExportCsv').on('click', () => {
                window.location.href = '/UserErrorReport/ExportCsv?' + buildQuery();
            });

            $('#uerUserTable').on('click', 'tbody tr', function () {
                var $user = $(this).find('.uer-user');
                if ($user.length) {
                    OpenDetails(Number($user.data('user-id')), $user.text());
                }
            });

            $('#uerHeatmap').on('click', '.uer-heat-cell[data-user-id]', function () {
                OpenDetails(Number($(this).data('user-id')), $(this).data('user-name'), $(this).data('category'));
            });

            $('#uerShowCalculation').on('change', function () {
                var show = $(this).is(':checked');
                $(this).closest('.uer-toggle').toggleClass('active', show);
                $('#uerCalculationCard').toggle(show);
            });

            $('#tab-uer-analytics').on('shown.bs.tab', () => loadAnalyticsTables());
            $('#tab-uer-overview').on('shown.bs.tab', () => {
                Object.keys(_charts).forEach(k => _charts[k].resize());
                if ($.fn.dataTable.isDataTable('#uerUserTable')) {
                    $('#uerUserTable').DataTable().columns.adjust();
                }
            });

            document.removeEventListener('skr-theme-changed', onThemeChanged as EventListener);
            document.addEventListener('skr-theme-changed', onThemeChanged as EventListener);

            $(window).off('resize.uerCharts').on('resize.uerCharts', () => {
                Object.keys(_charts).forEach(k => _charts[k].resize());
            });

            LoadData();
        }

        export function LoadData(): void {
            _query = buildQuery();
            PlsWait.ShowLoader(true);

            $.ajax({
                url: '/UserErrorReport/Data?' + _query,
                type: 'GET',
                success: (data) => {
                    _lastData = data;
                    render(data);
                    if ($('#uerTabAnalytics').hasClass('active')) {
                        loadAnalyticsTables();
                    }
                    PlsWait.ShowLoader(false);
                },
                error: (xhr) => {
                    var msg = (xhr.responseJSON && xhr.responseJSON.error) || xhr.statusText;
                    Notifications.GetNotification(msg, 'danger');
                    PlsWait.ShowLoader(false);
                }
            });
        }

        export function OpenDetails(userId: number, userName: string, category: string = ''): void {
            var url = '/UserErrorReport/UserErrors?' + _query + '&' + $.param({ userId: userId, category: category });
            $('#uerDetailsUser').text(userName);
            $('#uerDetailsCategory').text(category).toggle(!!category);

            $('#uerDetailsModal').off('shown.bs.modal').on('shown.bs.modal', () => {
                Common.DataTableCustom.Destroy('uerDetailsTable');
                Common.DataTableCustom.Init('uerDetailsTable', {
                    pageLength: 25,
                    order: [[0, 'desc']],
                    scrollX: false,
                    scrollY: '60vh',
                    columns: [{ title: 'Datum' }, { title: 'Kategorija' }, { title: 'Poruka' }]
                }, [
                    { targets: [0], width: '150px', className: 'uer-nowrap' },
                    { targets: [1], width: '190px', render: categoryCellRender },
                    { targets: [2], className: 'uer-msg-cell' }
                ], url);
            });
            $('#uerDetailsModal').modal('show');
        }

        function buildQuery(): string {
            var users = ($('#uerUsers').val() as string[]) || [];
            return $.param({
                from: toIso($('#dateFrom').val().toString()),
                to: toIso($('#dateTo').val().toString()),
                userIds: users,
                parserOnly: $('#uerParserOnly').is(':checked')
            }, true);
        }

        function applyPreset(preset: string): void {
            var today = new Date();
            var from: Date;
            var to: Date = today;

            switch (preset) {
                case 'thisMonth':
                    from = new Date(today.getFullYear(), today.getMonth(), 1);
                    break;
                case 'lastMonth':
                    from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                    to = new Date(today.getFullYear(), today.getMonth(), 0);
                    break;
                case 'last3Months':
                    from = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
                    break;
                default:
                    from = new Date(today.getFullYear(), 0, 1);
                    break;
            }

            $('#dateFrom').datepicker('update', toEu(from));
            $('#dateTo').datepicker('update', toEu(to));
        }

        function render(d: any): void {
            var fromText = formatDate(d.from);
            var toText = formatDate(d.to);
            $('#uerPeriodInfo').text(`Period: ${fromText} – ${toText} · usporedba s ${formatDate(d.previousFrom)} – ${formatDate(d.previousTo)}`);

            renderKpis(d.kpis);
            renderUserTable(d.users);
            renderUserCategoryChart(d);
            renderCategoryChart(d);
            renderTimeline(d);
            renderHeatmap(d);
            renderTopMessages(d);
            renderDayHour(d);
            renderCalculation(d);
        }

        function loadAnalyticsTables(): void {
            if (_analyticsQuery === _query) {
                ['uerAnalyticsErrors', 'uerAnalyticsScripts'].forEach(id => {
                    if ($.fn.dataTable.isDataTable('#' + id)) {
                        $('#' + id).DataTable().columns.adjust();
                    }
                });
                return;
            }

            _analyticsQuery = _query;
            initAnalyticsTable('uerAnalyticsErrors', '/UserErrorReport/AnalyticsErrors?' + _query,
                ['Log ID', 'Datum', 'Period', 'Korisnik', 'Kategorija', 'Poruka']);
            initAnalyticsTable('uerAnalyticsScripts', '/UserErrorReport/AnalyticsScripts?' + _query,
                ['ID', 'Datum', 'Period', 'Korisnik', 'Izvor', 'Naziv skripte']);
        }

        function initAnalyticsTable(tableId: string, url: string, titles: string[]): void {
            Common.DataTableCustom.Destroy(tableId);
            Common.DataTableCustom.Init(tableId, {
                pageLength: 25,
                order: [[1, 'desc']],
                scrollY: '50vh',
                columns: titles.map(t => ({ title: t }))
            }, [
                { targets: [0], width: '70px', className: 'text-right' },
                { targets: [1], width: '150px', className: 'uer-nowrap' },
                { targets: [2], width: '90px' },
                { targets: [5], className: 'uer-msg-cell' }
            ], url);
        }

        function categoryCellRender(data: any, type: string): string {
            if (type !== 'display' || !data) {
                return data;
            }
            return categoryBadge($('<textarea>').html(data).text());
        }

        function renderCalculation(d: any): void {
            var k = d.kpis;
            var period = `${formatDate(d.from)} – ${formatDate(d.to)}`;
            var previousPeriod = `${formatDate(d.previousFrom)} – ${formatDate(d.previousTo)}`;
            var parserOnly = $('#uerParserOnly').is(':checked');

            var rateFormula = (errors: number, attempts: number, rate: number) => rate == null
                ? 'nema pokušaja'
                : `${errors} / ${attempts} × 100 = <b>${pct(rate)}</b>`;
            var changeFormula = k.errorRate == null || k.previousErrorRate == null
                ? 'jedan od perioda nema pokušaja'
                : `${pct(k.errorRate)} − ${pct(k.previousErrorRate)} = <b>${formatNumber(k.errorRate - k.previousErrorRate)} p.b.</b>`;

            var rows: string[][] = [
                ['Greške', "Broj zapisa u dbo.Logs s action = 'ERROR' i user_id &gt; 0", `<b>${k.totalErrors}</b>`, `${k.previousTotalErrors}`],
                ['Uspješne skripte', 'Broj zapisa u dbo.Scripts + dbo.Insite_Scripts po create_date i id_user', `<b>${k.totalScripts}</b>`, `${k.previousTotalScripts}`],
                ['Pokušaji', 'Greške + uspješne skripte', `${k.totalErrors} + ${k.totalScripts} = <b>${k.totalAttempts}</b>`, `${k.previousTotalErrors} + ${k.previousTotalScripts} = ${k.previousTotalAttempts}`],
                ['Stopa grešaka', 'Greške / pokušaji × 100', rateFormula(k.totalErrors, k.totalAttempts, k.errorRate), rateFormula(k.previousTotalErrors, k.previousTotalAttempts, k.previousErrorRate)],
                ['Promjena stope', 'Tekuća stopa − prethodna stopa, u postotnim bodovima (p.b.)', changeFormula, ''],
                ['Aktivni korisnici', 'Korisnici s barem jednim pokušajem', `<b>${k.activeUsers}</b>`, `${k.previousActiveUsers}`],
                ['Medijan stope po korisniku', 'Srednja vrijednost sortiranih stopa aktivnih korisnika; ne ovisi o tome koliko skripti radi pojedinac', `<b>${pct(k.medianUserRate)}</b>`, pct(k.previousMedianUserRate)],
                ['Iznad ukupne stope', 'Broj aktivnih korisnika čija je stopa veća od ukupne stope', `<b>${k.usersAboveAverage}</b> / ${k.activeUsers}`, `${k.previousUsersAboveAverage} / ${k.previousActiveUsers}`],
                ['Stopa ponovljenih grešaka', 'Σ po korisniku (greške − broj različitih kategorija) / pokušaji × 100', rateFormula(k.totalRepeatedErrors, k.totalAttempts, k.repeatedRate), ''],
                ['Stopa kategorije', 'Greške kategorije / svi pokušaji × 100', k.topCategory ? `najčešća: <b>${escapeHtml(k.topCategory)}</b> ${k.topCategoryCount} / ${k.totalAttempts} = <b>${pct(k.topCategoryRate)}</b>` : '-', ''],
                ['Korisnik × kategorija', 'Greške kategorije korisnika / pokušaji tog korisnika × 100', 'po ćeliji', ''],
                ['Vremenska linija, dan × sat', 'Greške u intervalu / pokušaji u tom intervalu × 100; interval bez pokušaja nema stopu', 'po intervalu', '']
            ];

            var html = '<ul class="uer-calc-notes">'
                + `<li><b>Tekući period:</b> ${period} (uključivo). <b>Prethodni period</b> iste duljine: ${previousPeriod}.</li>`
                + '<li><b>Svi pokazatelji su stope</b>, tako da su korisnici s 2 i s 200 skripti usporedivi. Pokušaj = greška ili uspješno kreirana skripta.</li>'
                + "<li><b>Izvor grešaka:</b> dbo.Logs, action = 'ERROR'. Isključeni su zapisi s user_id = 0 (pozadinski poslovi) i 'ERROR SENDING DATA TO DIMT'.</li>"
                + `<li><b>Filter:</b> ${parserOnly ? 'samo greške parsiranja (bez kategorije Tehnička greška)' : 'sve kategorije'}; ${(($('#uerUsers').val() as string[]) || []).length > 0 ? 'odabrani korisnici' : 'svi korisnici'}.</li>`
                + `<li><b>Grupiranje vremenske linije:</b> ${d.granularity === 'week' ? 'po tjednima (period dulji od 60 dana)' : 'po danima'}.</li>`
                + '</ul>';

            html += '<table class="uer-top-messages uer-calc-table"><thead><tr><th>Pokazatelj</th><th>Formula</th><th>Tekući period</th><th>Prethodni period</th></tr></thead><tbody>';
            rows.forEach(r => { html += `<tr><td><b>${r[0]}</b></td><td>${r[1]}</td><td>${r[2]}</td><td>${r[3]}</td></tr>`; });
            html += '</tbody></table>';

            html += '<div class="uer-calc-subtitle">Pravila kategorizacije (prvo podudaranje pobjeđuje, bez obzira na velika/mala slova)</div>';
            html += '<table class="uer-top-messages uer-calc-table"><thead><tr><th>#</th><th>Kategorija</th><th>Regex nad porukom</th><th>Greške</th><th>% pokušaja</th></tr></thead><tbody>';
            d.categoryRules.forEach((r: any, i: number) => {
                var total = d.categoryTotals.filter((c: any) => c.category === r.category)[0] || { count: 0, rate: null };
                var pattern = r.pattern === '*' ? 'sve ostalo' : `<code>${escapeHtml(r.pattern)}</code>`;
                html += `<tr><td>${i + 1}</td><td>${categoryBadge(r.category)}</td><td>${pattern}</td><td class="text-right">${total.count}</td><td class="text-right">${pct(total.rate)}</td></tr>`;
            });
            html += '</tbody></table>';

            $('#uerCalculation').html(html);
        }

        function renderKpis(k: any): void {
            $('#kpiRate').text(pct(k.errorRate));
            $('#kpiRateDelta').html(deltaPp(k.errorRate, k.previousErrorRate));
            $('#kpiRateSub').text(`${k.totalErrors} grešaka / ${k.totalAttempts} pokušaja`);

            $('#kpiMedian').text(pct(k.medianUserRate));
            $('#kpiMedianDelta').html(deltaPp(k.medianUserRate, k.previousMedianUserRate));
            $('#kpiMedianSub').text(`${k.activeUsers} aktivnih korisnika`);

            $('#kpiAbove').text(`${k.usersAboveAverage} / ${k.activeUsers}`);
            $('#kpiAboveDelta').html(delta(k.usersAboveAverage, k.previousUsersAboveAverage));
            $('#kpiAboveSub').text(k.errorRate == null ? '' : `korisnika sa stopom > ${pct(k.errorRate)}`);

            $('#kpiRepeated').text(pct(k.repeatedRate));
            $('#kpiRepeatedSub').text(`${k.totalRepeatedErrors} ponovljenih grešaka`);

            $('#kpiTopCategory').text(k.topCategory || '-').attr('title', k.topCategory || '');
            $('#kpiTopCategorySub').text(k.topCategory ? `${pct(k.topCategoryRate)} pokušaja (${k.topCategoryCount})` : '');
        }

        function delta(current: number, previous: number): string {
            if (current === previous) {
                return '<span class="uer-delta--neutral">bez promjene</span>';
            }

            var cssClass = current > previous ? 'uer-delta--up' : 'uer-delta--down';
            var arrow = current > previous ? '▲' : '▼';
            var text = previous === 0
                ? 'novo (prije 0)'
                : formatNumber(Math.abs((current - previous) / previous * 100)) + ' % (prije ' + formatNumber(previous) + ')';

            return `<span class="${cssClass}">${arrow} ${text}</span>`;
        }

        function deltaPp(current: number, previous: number): string {
            if (current == null || previous == null) {
                return '<span class="uer-delta--neutral">nema usporedbe</span>';
            }

            var diff = Math.round((current - previous) * 10) / 10;
            if (diff === 0) {
                return '<span class="uer-delta--neutral">bez promjene</span>';
            }

            var cssClass = diff > 0 ? 'uer-delta--up' : 'uer-delta--down';
            var arrow = diff > 0 ? '▲' : '▼';
            return `<span class="${cssClass}">${arrow} ${formatNumber(Math.abs(diff))} p.b. (prije ${pct(previous)})</span>`;
        }

        function renderUserTable(users: any[]): void {
            var rows = users.map(u => [
                `<span class="uer-user" data-user-id="${u.userId}">${escapeHtml(u.userName)}</span>`,
                u.errorRate,
                deltaPp(u.errorRate, u.previousErrorRate),
                u.errors,
                u.attempts,
                u.repeatedRate,
                u.topCategory ? categoryBadge(u.topCategory) : '',
                u.lastError ? `<span style="display:none;">${sortableDate(u.lastError)}</span>${formatDateTime(u.lastError)}` : '',
                sparkline(u.sparkline)
            ]);

            var $table = $('#uerUserTable');
            if ($.fn.dataTable.isDataTable($table)) {
                var api = $table.DataTable();
                api.clear();
                api.rows.add(rows);
                api.draw();
                return;
            }

            var rateRender = (data: any, type: string) => type === 'display' || type === 'filter'
                ? (data == null ? '' : formatNumber(data))
                : (data == null ? -1 : data);

            Common.DataTableCustom.Init('uerUserTable', {
                data: rows,
                pageLength: 25,
                order: [[1, 'desc']],
                scrollY: '50vh'
            }, [
                { targets: [2, 8], orderable: false },
                { targets: [1, 5], render: rateRender },
                { targets: [1, 3, 4, 5], className: 'text-right' }
            ]);
        }

        function renderUserCategoryChart(d: any): void {
            var top = d.users.filter((u: any) => u.errorRate > 0).slice(0, 15);
            var datasets = d.categories.map((c: string) => ({
                label: c,
                backgroundColor: categoryColor(c),
                data: top.map((u: any) => u.byCategoryRate[c] || 0)
            })).filter((ds: any) => ds.data.some((v: number) => v > 0));

            var theme = themeColors();
            createChart('uerUserCategoryChart', top.length === 0, {
                type: 'horizontalBar',
                data: { labels: top.map((u: any) => u.userName), datasets: datasets },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: { position: 'bottom', labels: { boxWidth: 10, fontColor: theme.tick } },
                    tooltips: {
                        callbacks: {
                            label: (item: any, data: any) => `${data.datasets[item.datasetIndex].label}: ${pct(item.xLabel)}`,
                            footer: (items: any[]) => {
                                var user = top[items[0].index];
                                return `Ukupno: ${pct(user.errorRate)} (${user.errors} / ${user.attempts})`;
                            }
                        }
                    },
                    scales: {
                        xAxes: [{ stacked: true, ticks: { beginAtZero: true, fontColor: theme.tick, callback: (v: number) => v + ' %' }, gridLines: { color: theme.grid, zeroLineColor: theme.grid } }],
                        yAxes: [{ stacked: true, ticks: { fontColor: theme.tick }, gridLines: { display: false } }]
                    },
                    onClick: function (evt: any, elements: any[]) {
                        if (elements && elements.length) {
                            var user = top[elements[0]._index];
                            OpenDetails(user.userId, user.userName);
                        }
                    }
                }
            });
        }

        function renderCategoryChart(d: any): void {
            var items = d.categoryTotals.filter((c: any) => c.count > 0);
            var theme = themeColors();

            createChart('uerCategoryChart', items.length === 0, {
                type: 'doughnut',
                data: {
                    labels: items.map((c: any) => c.category),
                    datasets: [{
                        data: items.map((c: any) => c.rate),
                        backgroundColor: items.map((c: any) => categoryColor(c.category)),
                        borderColor: theme.background
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutoutPercentage: 55,
                    legend: { position: 'bottom', labels: { boxWidth: 10, fontColor: theme.tick } },
                    tooltips: {
                        callbacks: {
                            label: (item: any, data: any) => {
                                var c = items[item.index];
                                return `${c.category}: ${pct(c.rate)} pokušaja (${c.count})`;
                            }
                        }
                    }
                }
            });
        }

        function renderTimeline(d: any): void {
            var theme = themeColors();
            var datasets: any[] = [{
                label: 'Ukupna stopa',
                data: d.timeline.rate,
                borderColor: theme.line,
                backgroundColor: theme.fill,
                borderWidth: 2,
                fill: true,
                lineTension: 0.2,
                pointRadius: 2,
                spanGaps: true
            }];

            d.timeline.series.forEach((s: any, i: number) => {
                datasets.push({
                    label: s.userName,
                    data: s.rate,
                    borderColor: paletteColor((i + 1) % (_paletteSize - 1)),
                    backgroundColor: 'transparent',
                    borderWidth: 2,
                    fill: false,
                    lineTension: 0.2,
                    pointRadius: 2,
                    spanGaps: true
                });
            });

            $('#uerTimelineHint').text((d.granularity === 'week' ? 'Grupirano po tjednima' : 'Grupirano po danima') + ' · intervali bez pokušaja se preskaču');

            var hasData = d.timeline.attempts.some((v: number) => v > 0);
            createChart('uerTimelineChart', !hasData, {
                type: 'line',
                data: { labels: d.timeline.labels, datasets: datasets },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: { display: datasets.length > 1, labels: { boxWidth: 10, fontColor: theme.tick } },
                    tooltips: {
                        callbacks: {
                            label: (item: any, data: any) => {
                                var label = data.datasets[item.datasetIndex].label;
                                if (item.datasetIndex === 0) {
                                    return `${label}: ${pct(item.yLabel)} (${d.timeline.errors[item.index]} / ${d.timeline.attempts[item.index]})`;
                                }
                                return `${label}: ${pct(item.yLabel)}`;
                            }
                        }
                    },
                    scales: {
                        xAxes: [{ ticks: { fontColor: theme.tick, autoSkip: true, maxTicksLimit: 20 }, gridLines: { color: theme.grid, zeroLineColor: theme.grid } }],
                        yAxes: [{ ticks: { beginAtZero: true, fontColor: theme.tick, callback: (v: number) => v + ' %' }, gridLines: { color: theme.grid, zeroLineColor: theme.grid } }]
                    }
                }
            });
        }

        function renderHeatmap(d: any): void {
            var users = d.users.filter((u: any) => u.errors > 0);
            var categories: string[] = d.categories.filter((c: string) => users.some((u: any) => u.byCategory[c] > 0));

            if (users.length === 0) {
                $('#uerHeatmap').html(emptyHtml());
                return;
            }

            var max = 0;
            users.forEach((u: any) => categories.forEach(c => { max = Math.max(max, u.byCategoryRate[c] || 0); }));

            var html = '<table class="uer-heatmap"><thead><tr><th>Korisnik</th>';
            categories.forEach(c => { html += `<th>${escapeHtml(c)}</th>`; });
            html += '<th>Ukupna stopa</th></tr></thead><tbody>';

            users.forEach((u: any) => {
                html += `<tr><td class="uer-heat-user">${escapeHtml(u.userName)}</td>`;
                categories.forEach(c => {
                    var rate = u.byCategoryRate[c] || 0;
                    var count = u.byCategory[c] || 0;
                    html += heatCell(rate, max, formatNumber(rate),
                        `title="${escapeHtml(c)}: ${count} / ${u.attempts} pokušaja" data-user-id="${u.userId}" data-user-name="${escapeHtml(u.userName)}" data-category="${escapeHtml(c)}"`);
                });
                html += `<td class="uer-heat-total">${pct(u.errorRate)}</td></tr>`;
            });

            html += '</tbody></table>';
            $('#uerHeatmap').html(html);
        }

        function renderTopMessages(d: any): void {
            if (d.topMessages.length === 0) {
                $('#uerTopMessages').html(emptyHtml());
                return;
            }

            var html = '<table class="uer-top-messages"><thead><tr><th>#</th><th>Poruka</th><th>Kategorija</th><th>% pokušaja</th><th>Broj</th><th>Korisnika</th></tr></thead><tbody>';
            d.topMessages.forEach((m: any, i: number) => {
                html += `<tr><td>${i + 1}</td><td class="uer-msg">${escapeHtml(m.message)}</td><td>${categoryBadge(m.category)}</td><td class="text-right">${pct(m.rate)}</td><td class="text-right">${m.count}</td><td class="text-right">${m.users}</td></tr>`;
            });
            html += '</tbody></table>';
            $('#uerTopMessages').html(html);
        }

        function renderDayHour(d: any): void {
            var errors: number[][] = d.dayHourErrors;
            var attempts: number[][] = d.dayHourAttempts;
            var max = 0;

            errors.forEach((row, day) => row.forEach((e, hour) => {
                if (attempts[day][hour] > 0) {
                    max = Math.max(max, e / attempts[day][hour] * 100);
                }
            }));

            if (max === 0) {
                $('#uerDayHour').html(emptyHtml());
                return;
            }

            var html = '<table class="uer-heatmap uer-heatmap--compact"><thead><tr><th></th>';
            for (var h = 0; h < 24; h++) {
                html += `<th>${h}</th>`;
            }
            html += '</tr></thead><tbody>';

            errors.forEach((row, day) => {
                html += `<tr><td class="uer-heat-user">${_dayNames[day]}</td>`;
                row.forEach((e, hour) => {
                    var a = attempts[day][hour];
                    var rate = a > 0 ? e / a * 100 : 0;
                    var title = a > 0
                        ? `${_dayNames[day]} ${hour}:00 – ${pct(rate)} (${e} / ${a})`
                        : `${_dayNames[day]} ${hour}:00 – nema pokušaja`;
                    html += heatCell(rate, max, '', `title="${title}"`);
                });
                html += '</tr>';
            });

            html += '</tbody></table>';
            $('#uerDayHour').html(html);
        }

        function heatCell(value: number, max: number, text: string, attributes: string): string {
            if (!value) {
                return `<td class="uer-heat-cell uer-heat-cell--empty" ${attributes}>${text ? '·' : ''}</td>`;
            }

            var maxAlpha = parseFloat(cssVar('--uer-heat-max')) || 0.8;
            var alpha = 0.12 + (maxAlpha - 0.12) * value / max;
            return `<td class="uer-heat-cell" style="background-color: rgba(${cssVar('--uer-accent-rgb')}, ${alpha.toFixed(2)});" ${attributes}>${text}</td>`;
        }

        function createChart(canvasId: string, isEmpty: boolean, config: any): void {
            if (_charts[canvasId]) {
                try { _charts[canvasId].destroy(); } catch (e) { }
                delete _charts[canvasId];
            }

            var $canvas = $('#' + canvasId);
            $canvas.siblings('.uer-empty').remove();

            if (isEmpty) {
                $canvas.hide().after(emptyHtml());
                return;
            }

            $canvas.show();
            _charts[canvasId] = new Chart(canvasId, config);
        }

        function sparkline(values: number[]): string {
            if (!values || values.length < 2) {
                return '';
            }

            var clean = values.map(v => v == null ? 0 : v);
            var width = 90;
            var height = 22;
            var max = Math.max.apply(null, clean.concat([1]));
            var step = width / (clean.length - 1);
            var points = clean.map((v, i) => `${(i * step).toFixed(1)},${(height - 2 - (v / max) * (height - 4)).toFixed(1)}`).join(' ');

            return `<svg class="uer-sparkline" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}"><polyline points="${points}" /></svg>`;
        }

        function pct(value: number): string {
            return value == null ? '-' : formatNumber(value) + ' %';
        }

        function cssVar(name: string): string {
            return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
        }

        function paletteColor(index: number): string {
            return cssVar('--uer-c' + index);
        }

        function categoryIndex(category: string): number {
            if (category === 'Tehnička greška') {
                return _paletteSize - 1;
            }
            var categories: string[] = _lastData ? _lastData.categories : [];
            var index = categories.indexOf(category);
            return (index < 0 ? 0 : index) % (_paletteSize - 1);
        }

        function categoryColor(category: string): string {
            return paletteColor(categoryIndex(category));
        }

        function categoryBadge(category: string): string {
            return `<span class="uer-badge uer-cat-${categoryIndex(category)}">${escapeHtml(category)}</span>`;
        }

        function themeColors(): { tick: string, grid: string, line: string, fill: string, background: string } {
            var isDark = document.documentElement.getAttribute('data-theme') === 'dark';
            return {
                tick: isDark ? '#e5e7eb' : '#475467',
                grid: isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.1)',
                line: cssVar('--uer-accent'),
                fill: `rgba(${cssVar('--uer-accent-rgb')}, 0.12)`,
                background: isDark ? '#1e2130' : '#fff'
            };
        }

        function onThemeChanged(): void {
            if (_lastData) {
                render(_lastData);
            }
        }

        function emptyHtml(): string {
            return '<div class="dsh-empty uer-empty"><i class="fas fa-chart-bar"></i><span>Nema podataka</span></div>';
        }

        function escapeHtml(value: any): string {
            return String(value == null ? '' : value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }

        function pad(value: number): string {
            return value < 10 ? '0' + value : value.toString();
        }

        function toIso(eu: string): string {
            var parts = eu.split('.');
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }

        function toEu(date: Date): string {
            return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
        }

        function parseParts(value: string): number[] {
            return value.split(/[-T:.]/).map(p => parseInt(p, 10));
        }

        function formatDate(value: string): string {
            var p = parseParts(value);
            return `${pad(p[2])}.${pad(p[1])}.${p[0]}`;
        }

        function formatDateTime(value: string): string {
            var p = parseParts(value);
            return `${pad(p[2])}.${pad(p[1])}.${p[0]} ${pad(p[3] || 0)}:${pad(p[4] || 0)}`;
        }

        function sortableDate(value: string): string {
            var p = parseParts(value);
            return `${p[0]}${pad(p[1])}${pad(p[2])}${pad(p[3] || 0)}${pad(p[4] || 0)}`;
        }

        function formatNumber(value: number): string {
            return (Math.round(value * 10) / 10).toLocaleString('hr-HR');
        }
    }
}